module.exports = __webpack_public_path__ + "media/images/flags/un-bcce3131578604105d40c3f1d9c312f4.svg";